import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const katameNoKataCriteriaI18n: CriterionLocaleBundle = {
  ja: {
    'katame-gen-start-pos': {
      text: '受が開始位置を決める。',
    },
    'katame-gen-movement-bow': {
      text: '移動：開始時に受が一歩前進する。終了時に取が二歩後退し、その後、受が一歩後退する。礼。',
    },
    'katame-gen-osaekomi-distance': {
      text: '抑込技（Osae-komi-waza）の距離と位置：跪踞（kyoshi）から遠間（toma、約 1.2 m）および近間（chikama、約 30 cm）への移行。袈裟固（Kesa-gatame）から崩上四方固（Kuzure-kami-shiho-gatame）まで、評価基準表の指定どおり。',
    },
    'katame-gen-shime-distance': {
      text: '絞技（Shime-waza）の距離と位置：取は跪踞（kyoshi）で遠間（toma）／近間（chikama）から移動し、絞技では受にまたがり、裸絞（Hadaka-jime）の組から逆十字絞（Gyaku-juji-jime）までは受の後ろへ歩いて移るなど、評価基準の指定どおり。',
    },
    'katame-gen-kansetsu-distance': {
      text: '関節技（Kansetsu-waza）の距離と位置：腕緘（Ude-garami）から足緘（Ashi-garami）までの移行。終了時、取は二歩退いて遠間（toma）、受は一歩退き、礼など評価基準の指定どおり。',
    },
    'katame-gen-shikko': {
      text: '取または受が膝行（Shikko）の際に膝を上げる。',
    },
    'katame-gen-steps-chikama': {
      text: '歩数が正しくても距離が正しくない、または各技の終わりに取が近間（chikama）へ戻らない。',
    },
    'katame-gen-half-step': {
      text: '技を行う前に取が半歩近づく。',
    },
    'katame-gen-wrong-kyoshi': {
      text: '取が跪踞（kyoshi）で、技を始める前に受の体に対して誤った位置を取る。',
    },
    'katame-gen-chikama-break': {
      text: '取が近間（chikama）で半歩前進または後退して位置を崩す。',
    },

    'katame-kesa-gatame-perf': {
      text: '行い方：右腕の握り、左腋下で左肩を制することなど。',
    },
    'katame-kesa-gatame-escape-attempts': {
      text: '技の間に受は三回の逃れの試みを示さなければならない。',
    },
    'katame-kesa-gatame-escape-reactions': {
      text: 'それぞれの逃れの試みに対し、取は対応する反応を示す。対応は連続性があり、合理的でなければならない。',
    },

    'katame-kata-gatame-perf': {
      text: '行い方：受の右肘を受の右耳の方へ押すことなど。',
    },
    'katame-kata-gatame-escape-attempts': {
      text: '技の間に受は三回の逃れの試みを示さなければならない。',
    },
    'katame-kata-gatame-escape-reactions': {
      text: 'それぞれの逃れの試みに対し、取は対応する反応を示す。対応は連続性があり、合理的でなければならない。',
    },

    'katame-kami-shiho-gatame-perf': {
      text: '行い方：通常の接近に加えた膝をついての接近、両手の使い方など。',
    },
    'katame-kami-shiho-gatame-escape-attempts': {
      text: '技の間に受は三回の逃れの試みを示さなければならない。',
    },
    'katame-kami-shiho-gatame-escape-reactions': {
      text: 'それぞれの逃れの試みに対し、取は対応する反応を示す。対応は連続性があり、合理的でなければならない。',
    },

    'katame-yoko-shiho-gatame-perf': {
      text: '行い方：腕の動き、受の腋に当てる膝、帯の握り（左手、右手）、右膝で制することなど。',
    },
    'katame-yoko-shiho-gatame-escape-attempts': {
      text: '技の間に受は三回の逃れの試みを示さなければならない。',
    },
    'katame-yoko-shiho-gatame-escape-reactions': {
      text: 'それぞれの逃れの試みに対し、取は対応する反応を示す。対応は連続性があり、合理的でなければならない。',
    },

    'katame-kuzure-kami-shiho-gatame-perf': {
      text: '行い方：通常の接近に加えた斜め前方への一歩、腕の握り、受の右腕を取の右大腿に置くことなど。',
    },
    'katame-kuzure-kami-shiho-gatame-escape-attempts': {
      text: '技の間に受は三回の逃れの試みを示さなければならない。',
    },
    'katame-kuzure-kami-shiho-gatame-escape-reactions': {
      text: 'それぞれの逃れの試みに対し、取は対応する反応を示す。対応は連続性があり、合理的でなければならない。',
    },

    'katame-kata-juji-jime-perf': {
      text: '行い方：膝を受の腋の近くに置くこと、両手の使い方。取は両脚で受の体を止めて制する。',
    },
    'katame-kata-juji-jime-escape': {
      text: '受は両手で取の両腕を押して逃れようとする。取は頭を前方へ、畳に向けて動かしながら絞めを続ける。',
    },

    'katame-hadaka-jime-perf': {
      text: '行い方：両腕を同時に用いることなど。',
    },
    'katame-hadaka-jime-escape': {
      text: '受は両手で取の上腕を引き下げて逃れようとする。取は後退して受を制しながら絞めを続ける。',
    },

    'katame-okuri-eri-jime-perf': {
      text: '行い方：左手、右手、左手の順序など。',
    },
    'katame-okuri-eri-jime-escape': {
      text: '受は両手で取の上腕を引き下げて逃れようとする。取は後退し、右膝で受の体を軽く支えて制しながら絞めを続ける。',
    },

    'katame-kataha-jime-perf': {
      text: '行い方：両手、左の手のひらと腕の使い方。取は右へ回り、右脚を後方および側方へ動かして絞める。',
    },
    'katame-kataha-jime-escape': {
      text: '受は右手で自分の左手首を握り、下へ引いて逃れようとする。取は絞めを続ける。',
    },

    'katame-gyaku-juji-jime-perf': {
      text: '行い方：膝を受の腋の近くに置くこと、両手の使い方など。取は両脚で受の体を止めて制する。',
    },
    'katame-gyaku-juji-jime-escape': {
      text: '受は左手で押し、右手で引き下げて逃れようとする。取は絞めを続け、両足を交差して横向きに転がる。',
    },

    'katame-ude-garami-perf': {
      text: '取は受の右腕を動かして近づく。受は左手で取の右襟を握ろうとして攻撃する。',
    },
    'katame-ude-garami-escape': {
      text: '受は左肩と背中を上げて逃れようとする。取は腕の関節技を続ける。',
    },

    'katame-ude-hishigi-juji-gatame-perf': {
      text: '取が近づくと、受は右手を伸ばして取の左襟を握ろうとする。取はまず右手で受の右手首を握り、次に左手でその下を握って、受の腕を自分の胸に固定する。右足を受の腋下に置き、左足を受の頭の周りへ踏み出す。両大腿で受の腕を挟んで保持し、両膝を締め、仰向けになって腰を上げる。',
    },
    'katame-ude-hishigi-juji-gatame-escape': {
      text: '受は背中を上げ、左へ回りながら腕を引いて逃れようとする。取は腕の関節技を続ける。',
    },

    'katame-ude-hishigi-ude-gatame-perf': {
      text: '取が受の右腕を動かして近づくと、受は左手を伸ばして取の右襟を握ろうとする。取は首の右側と右肩で受の左手首を固定し、右手、左手の順に肘に当て、右膝で受の体を制して腕の関節技を施す。',
    },
    'katame-ude-hishigi-ude-gatame-escape': {
      text: '受は腕を下へ引いて逃れようとする。取は腕の関節技を続ける。',
    },

    'katame-ude-hishigi-hiza-gatame-perf': {
      text: '取は左の手のひらを受の右肘に当て、受の手首を左腋下に挟む。右足を受の鼠径部に当て、右側へ横になる。左足を受の右側で内向きにし、足先で受を制する。左膝の内側で自分の左手を押し、腕の関節技を施す。',
    },
    'katame-ude-hishigi-hiza-gatame-escape': {
      text: '受は腕を前へ押して逃れようとする。取は腕の関節技を続ける。',
    },

    'katame-ashi-garami-perf': {
      text: '取は巴投（Tomoe-nage）を試みる。受は右足を前に進めて取の体を引き上げ、防御する。取は右足で受の左膝の内側を押し、左脚を受の右膝に巻きつけて脚の関節技を施す。',
    },
    'katame-ashi-garami-escape': {
      text: '受は左へ回って逃れようとする。取は脚の関節技を続ける。',
    },
  },

  'zh-Hant': {
    'katame-gen-start-pos': {
      text: '由受決定起始位置。',
    },
    'katame-gen-movement-bow': {
      text: '移動：開始時受向前一步；結束時取後退兩步，然後受後退一步。行禮。',
    },
    'katame-gen-osaekomi-distance': {
      text: '壓技（Osae-komi-waza）的距離與位置：從跪踞（kyoshi）、遠間（toma、約 1.2 米）與近間（chikama、約 30 厘米）的轉換，涵蓋袈裟固（Kesa-gatame）至崩上四方固（Kuzure-kami-shiho-gatame），依評分準則表所定。',
    },
    'katame-gen-shime-distance': {
      text: '絞技（Shime-waza）的距離與位置：取在跪踞（kyoshi）下由遠間（toma）／近間（chikama）移動，絞技時跨坐於受身上；裸絞（Hadaka-jime）組至逆十字絞（Gyaku-juji-jime）則步行至受後方等，依評分準則所定。',
    },
    'katame-gen-kansetsu-distance': {
      text: '關節技（Kansetsu-waza）的距離與位置：腕緘（Ude-garami）至足緘（Ashi-garami）的轉換；結束時取後退兩步至遠間（toma），受後退一步，並行禮等，依評分準則所定。',
    },
    'katame-gen-shikko': {
      text: '取或受在膝行（Shikko）移動時抬起膝部。',
    },
    'katame-gen-steps-chikama': {
      text: '步數正確但距離不正確，或取未在每項技術結束後回到近間（chikama）。',
    },
    'katame-gen-half-step': {
      text: '取在施技前接近半步。',
    },
    'katame-gen-wrong-kyoshi': {
      text: '取在跪踞（kyoshi）時，相對受的身體採取了不正確的施技起始位置。',
    },
    'katame-gen-chikama-break': {
      text: '取在近間（chikama）向前或向後移半步，偏離原有位置。',
    },

    'katame-kesa-gatame-perf': {
      text: '施技方式：右臂的握持、在左腋下控制左肩等。',
    },
    'katame-kesa-gatame-escape-attempts': {
      text: '技術進行中，受必須展示三次逃脫嘗試。',
    },
    'katame-kesa-gatame-escape-reactions': {
      text: '對每次逃脫嘗試，取須展示相應的應對，各動作應連貫且合理。',
    },

    'katame-kata-gatame-perf': {
      text: '施技方式：將受的右肘推向其右耳等。',
    },
    'katame-kata-gatame-escape-attempts': {
      text: '技術進行中，受必須展示三次逃脫嘗試。',
    },
    'katame-kata-gatame-escape-reactions': {
      text: '對每次逃脫嘗試，取須展示相應的應對，各動作應連貫且合理。',
    },

    'katame-kami-shiho-gatame-perf': {
      text: '施技方式：一般接近動作加上跪姿接近動作、雙手的運用等。',
    },
    'katame-kami-shiho-gatame-escape-attempts': {
      text: '技術進行中，受必須展示三次逃脫嘗試。',
    },
    'katame-kami-shiho-gatame-escape-reactions': {
      text: '對每次逃脫嘗試，取須展示相應的應對，各動作應連貫且合理。',
    },

    'katame-yoko-shiho-gatame-perf': {
      text: '施技方式：手臂動作、膝部貼受腋下、腰帶握法（左手、右手）、右膝控制等。',
    },
    'katame-yoko-shiho-gatame-escape-attempts': {
      text: '技術進行中，受必須展示三次逃脫嘗試。',
    },
    'katame-yoko-shiho-gatame-escape-reactions': {
      text: '對每次逃脫嘗試，取須展示相應的應對，各動作應連貫且合理。',
    },

    'katame-kuzure-kami-shiho-gatame-perf': {
      text: '施技方式：一般接近動作加上斜前方一步、手臂握法、將受的右臂置於取的右大腿上等。',
    },
    'katame-kuzure-kami-shiho-gatame-escape-attempts': {
      text: '技術進行中，受必須展示三次逃脫嘗試。',
    },
    'katame-kuzure-kami-shiho-gatame-escape-reactions': {
      text: '對每次逃脫嘗試，取須展示相應的應對，各動作應連貫且合理。',
    },

    'katame-kata-juji-jime-perf': {
      text: '施技方式：雙膝接近受的腋下、雙手的運用；取以雙腿封阻及控制受的身體。',
    },
    'katame-kata-juji-jime-escape': {
      text: '受以雙手推取的雙臂，嘗試逃脫。取將頭向前移向榻榻米，繼續施絞。',
    },

    'katame-hadaka-jime-perf': {
      text: '施技方式：雙臂同時動作等。',
    },
    'katame-hadaka-jime-escape': {
      text: '受以雙手向下拉取的上臂，嘗試逃脫。取後移並控制受，繼續施絞。',
    },

    'katame-okuri-eri-jime-perf': {
      text: '施技方式：左手、右手、左手的順序等。',
    },
    'katame-okuri-eri-jime-escape': {
      text: '受以雙手向下拉取的上臂，嘗試逃脫。取後移，以右膝輕托受的身體並控制受，繼續施絞。',
    },

    'katame-kataha-jime-perf': {
      text: '施技方式：雙手、左掌及手臂的運用；取向右轉，右腿向後及向側方移動以施絞。',
    },
    'katame-kataha-jime-escape': {
      text: '受以右手握自己的左手腕並向下拉，嘗試逃脫。取繼續施絞。',
    },

    'katame-gyaku-juji-jime-perf': {
      text: '施技方式：雙膝接近受的腋下、雙手的運用等；取以雙腿封阻及控制受的身體。',
    },
    'katame-gyaku-juji-jime-escape': {
      text: '受左手推、右手向下拉，嘗試逃脫。取繼續施絞，側身滾倒並交叉雙腳。',
    },

    'katame-ude-garami-perf': {
      text: '取移開受的右臂並接近；受以左手嘗試握取的右襟，發動攻擊。',
    },
    'katame-ude-garami-escape': {
      text: '受抬起左肩及背部，嘗試逃脫。取繼續施手臂關節技。',
    },

    'katame-ude-hishigi-juji-gatame-perf': {
      text: '取接近時，受以右手向上伸，嘗試握取的左襟。取先以右手握受的右手腕，再以左手握其下方，將受的手臂固定在自己胸前；右腳置於受的腋下，左腳繞過受的頭部；以雙大腿夾住受的手臂，收緊雙膝，躺下並抬高髖部。',
    },
    'katame-ude-hishigi-juji-gatame-escape': {
      text: '受抬起背部、拉回手臂並向左轉，嘗試逃脫。取繼續施手臂關節技。',
    },

    'katame-ude-hishigi-ude-gatame-perf': {
      text: '取移開受的右臂後接近時，受以左手向上伸，嘗試握取的右襟。取施手臂關節技，以頸部右側及右肩固定受的左手腕，右手、左手依序置於肘部，以右膝控制受的身體。',
    },
    'katame-ude-hishigi-ude-gatame-escape': {
      text: '受將手臂向下拉，嘗試逃脫。取繼續施手臂關節技。',
    },

    'katame-ude-hishigi-hiza-gatame-perf': {
      text: '取左掌置於受的右肘，將受的手腕夾於左腋下，右腳置於受的腹股溝部位，向右側躺下；左腳在受的右側向內轉，以腳尖控制受；以左膝內側壓自己的左手，施手臂關節技。',
    },
    'katame-ude-hishigi-hiza-gatame-escape': {
      text: '受將手臂向前推，嘗試逃脫。取繼續施手臂關節技。',
    },

    'katame-ashi-garami-perf': {
      text: '取嘗試施巴投（Tomoe-nage）；受右腳向前移並將取的身體向上拉以防守。取以右腳推受左膝內側，以左腿繞住受的右膝，施腿部關節技。',
    },
    'katame-ashi-garami-escape': {
      text: '受向左轉，嘗試逃脫。取繼續施腿部關節技。',
    },
  },
}
